import config from 'src/config';
import { ResponseDto } from 'src/dtos/common/responseDto';
import { TQCInspectSpecDto } from 'src/dtos/tqcInspectSpec/tqcInspectSpecDto';
import { getData } from 'src/utils/axios/serverHelper';

const baseUrl = `${config.apiUrl}/tqcInspectSpec`;

/** 검사기준 코드검색 모달용 목록을 조회한다. */
export const getTqcInspectSpecPopupList = async (
	searchText: string,
	itemCd?: string,
	excludeRegistered = false,
) =>
	getData<ResponseDto<TQCInspectSpecDto[]>>(`${baseUrl}/modal`, {
		params: { searchText, itemCd: itemCd || '', excludeRegistered },
	});
